import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialCodiceAtecoState } from './codice_ateco.state';
import { getCodiceAteco } from './codice_ateco.utility';
import { GetCodiceAtecoGQL } from '../../_graphql/generated';

export const CodiceAtecoStore = signalStore(
  { providedIn: 'root' },
  withState(initialCodiceAtecoState),
  withProps(() => ({
    getter: inject(GetCodiceAtecoGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getCodiceAteco(injector, store, getter),
  })),
);
